export default __webpack_public_path__ + "static/media/replay_button.5140e004.png";